(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index--banner"] && !Shopify.designMode) return;
  try {
    
function banner_slideshow_slider() {
   var SwiperLatestBannerHero = new Swiper(".banner-hero-slider", {
      slidesPerView: 1,
      effect: 'fade',
      loop: true,
      autoplay: {
          delay: 2500,
       },
      speed: 2000
   });
}

$(document).on('shopify:section:load shopify:section:unload shopify:block:select shopify:block:deselect shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
  banner_slideshow_slider();
});

$(document).ready(function(e){
  banner_slideshow_slider()
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index--featured-collection-list"] && !Shopify.designMode) return;
  try {
    
function collection_list_slideshow_slider() {
  if ($(".feature-collection-list-slider").length > 0){
   var SwiperLatestFeatureCol = new Swiper(".feature-collection-list-slider", {
      slidesPerView: 1.54,
      loop: true,
      freeMode: true,
      spaceBetween: 16,
      Infinity:true,
      speed:800,    
      breakpoints: {
        540: {
          slidesPerView:2.5,          
        }, 
        767: {
          slidesPerView:3,
        }, 
        1140: {
          slidesPerView:3,
          spaceBetween: 20,
        },
        1560: {
          slidesPerView:4,
        }
      }
    });
  }
  if ($(".feature-top-slider").length > 0){
   var SwiperLatestFeatureCol = new Swiper(".feature-top-slider", {      
      freeMode: true,
      Infinity:true,
      loop: true,
      autoplay: true,
      autoplay: {
      delay: 0,
      disableOnInteraction: false,
      },
      slidesPerView: 'auto',
      spaceBetween: 8,
      speed: 6000
    });
  }
}

$(document).on('shopify:section:load shopify:section:unload shopify:block:select shopify:block:deselect shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
  collection_list_slideshow_slider();
});

$(document).ready(function(e){
  collection_list_slideshow_slider()
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index--featured-collection"] && !Shopify.designMode) return;
  try {
    
function collection_slideshow_slider() {
  if ($(".feature-seller-slider").length > 0){
   var SwiperLatestFeatureSel = new Swiper(".feature-seller-slider", {
     slidesPerView:1.54,
     loop: true,     
     freeMode: true,
     spaceBetween: 12,
     Infinity:true,
     speed:800,
     navigation: {
       nextEl: '.feature-seller-arrow .swiper-button-next',
       prevEl: '.feature-seller-arrow .swiper-button-prev',
     },
     breakpoints: {
       540: {
         slidesPerView:2.5,
         spaceBetween: 12,
       },
       767: {
         slidesPerView:3,
         spaceBetween: 12,
       },
       1140: {
         slidesPerView:4,
         spaceBetween: 20,
       },
       1560: {
         slidesPerView:5,
       }
     }
   });
  }
}

$(document).on('shopify:section:load shopify:section:unload shopify:block:select shopify:block:deselect shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
  collection_slideshow_slider();
});

$(document).ready(function(e){
  collection_slideshow_slider()
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index--grid-with-text"] && !Shopify.designMode) return;
  try {
    
  function grid_slideshow_slider() {
    if ($(".quality-slider").length > 0){
       var SwiperLatest = new Swiper(".quality-slider", {
        slidesPerView:1.54,
        loop: false, 
        mousewheel: {
          enabled: true,
          sensitivity: 4,
        },
        freeMode: true,
        spaceBetween: 8,
        Infinity:false,
        speed:800,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        breakpoints: {
          540: {
            slidesPerView:2.5,
            spaceBetween: 8,
          },
          767: {
            slidesPerView:3.07,
            spaceBetween: 8,
          },
          1140: {
            slidesPerView:4,
            spaceBetween: 20,
          },
          1560: {
            slidesPerView:5,
            spaceBetween: 20,
          }
        }
      });
    }
  }

  $(document).on('shopify:section:load shopify:section:unload shopify:block:select shopify:block:deselect shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
    grid_slideshow_slider();
  });

  $(document).ready(function(e){
    grid_slideshow_slider()
  });

  } catch(e) { console.error(e); }
})();
})();
